import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import {
  EPlatform,
  ERequestState,
  ImportRequestApi,
  ImportRequestDto,
  MembershipRequestDto,
  RequestDto,
} from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { DrupalImportRequestForm } from "./DrupalImportRequestForm";

export interface IDrupalImportRequestPageProps {}

export const DrupalImportRequestPage: React.FunctionComponent<IDrupalImportRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const importRequestId = React.useMemo(() => +id, [id]);

  const { t } = useTl();
  const api = useApiService(ImportRequestApi);
  // TODO-CRR : saving is used, but not saveItem???
  const { data, loading, saving } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (apiId = importRequestId) =>
          apiId > 0
            ? api.get(apiId)
            : new ImportRequestDto({
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: (d: ImportRequestDto) =>
          api.save(MembershipRequestDto.fromJS({ ...d, isPortal: true })),
        deleteApiFn: () => {},
      }),
      [api, importRequestId]
    ),
    [importRequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet
        title={`${t(ETLCodes.Payment)}: ${t(ETLCodes.ImportRequest)}`}
      >
        <div>
          {saving ? (
            <Spinner />
          ) : (
            <DrupalRequestResume
              requestForm={
                <DrupalImportRequestForm
                  importRequestId={importRequestId}
                  initialdata={data}
                  loading={saving}
                />
              }
              requestDto={data?.request}
              bill={null}
            />
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
